import { render, staticRenderFns } from "./DynamicContentCard.vue?vue&type=template&id=7d4c520a&scoped=true"
import script from "./DynamicContentCard.vue?vue&type=script&lang=js"
export * from "./DynamicContentCard.vue?vue&type=script&lang=js"
import style0 from "./DynamicContentCard.vue?vue&type=style&index=0&id=7d4c520a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4c520a",
  null
  
)

export default component.exports